// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1CmUd","itemTitle":"ClientEmergencyInfo_itemTitle__1DpET","itemText":"ClientEmergencyInfo_itemText__3TozX"};